import {
  GetDamagedAdjusterAttachedImagesQueryParamsType,
  GetDamagedAdjusterAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQuery.type';
import { getAdjusterAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedAdjusterAttachedImagesQueryOptions = (
  params: GetDamagedAdjusterAttachedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: [
      'damagedAdjusterAttachedImages',
      params.damaged_id,
      params.fileType,
      params.id,
      params.type,
    ],
    queryFn: () => getAdjusterAttachedImagesFunction(params),
    enabled: true,
    meta: {
      onSuccess: params?.onSuccess,
    },
    select: (data): GetDamagedAdjusterAttachedImagesQueryResponseType => {
      // need more refactors to handle this api perfect :)
      if (params.type !== 'vehicle') {
        return {
          damaged_parts: [],
          vehicle:
            data as unknown as GetDamagedAdjusterAttachedImagesQueryResponseType['vehicle'],
        };
      }
      return data;
    },
  });
};
